export default function ArenaIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.115 32.744"
      width={props.size || "2.7rem"}
      height={props.size || "2.7rem"}
      style={{ color: props.color || "#6f6f6f", ...props.style }}
    >
      <path d="M25.048,12.057V32.743h-.523V14.153a11.534,11.534,0,1,0-23.068,0V32.744H.933V12.057a12.057,12.057,0,1,1,24.115,0Z" fill="currentColor" transform="translate(-954.537 -5187) translate(953.604 5187)"/>
      <path d="M57.02,66.5v17.55H56.5V68.284a9.44,9.44,0,1,0-18.88,0v15.77h-.523V66.5a9.963,9.963,0,1,1,19.927,0Z" fill="currentColor" transform="translate(-954.537 -5187) translate(919.538 5133.734)"/>
      <path d="M89.018,120.976V135.39h-.523V122.443a7.345,7.345,0,0,0-14.69,0V135.39h-.523V120.976a7.869,7.869,0,0,1,15.737,0Z" fill="currentColor" transform="translate(-954.537 -5187) translate(885.446 5080.442)"/>
      <path d="M120.99,175.424V186.7h-.523V176.576a5.25,5.25,0,1,0-10.5,0V186.7h-.523V175.424a5.774,5.774,0,1,1,11.548,0Z" fill="currentColor" transform="translate(-954.537 -5187) translate(851.378 5027.175)"/>
      <path d="M152.962,229.844v8.142h-.524v-7.3a3.156,3.156,0,1,0-6.313,0v7.3H145.6v-8.142a3.68,3.68,0,1,1,7.36,0Z" fill="currentColor" transform="translate(-954.537 -5187) translate(817.312 4973.933)"/>
      <path d="M184.96,284.316v5.006h-.524v-4.481a1.062,1.062,0,1,0-2.123,0v4.481h-.523v-5.006a1.585,1.585,0,1,1,3.17,0Z" fill="currentColor" transform="translate(-954.537 -5187) translate(783.22 4920.642)"/>
    </svg>
  );
}
